import React from 'react';
export default function toArray(children) {
  var ret = [];
  React.Children.forEach(children, function (c) {
    ret.push(c);
  });
  return ret;
}


//////////////////
// WEBPACK FOOTER
// ../~/_rc-util@4.11.0@rc-util/es/Children/toArray.js
// module id = 33
// module chunks = 0